import clsx from 'clsx';
import {
  FC,
  useState,
  useRef,
  useEffect,
  MutableRefObject
} from 'react';

import Board from './Board';
import Ribbon from './Ribbon';
import Alpha from './Alpha';

import TinyColor, { ITinyColor } from '../../../utils/color';
import { TPropsMain } from './types';

const Panel: FC<TPropsMain> = ({
  alpha,
  className,
  hex,
  colorBoardHeight,
  showAlpha,
  onChange
}) => {
  const node = useRef() as MutableRefObject<HTMLDivElement>;

  const colorConvert = new TinyColor(hex) as ITinyColor;
  colorConvert.alpha = alpha;
  const [state, setState] = useState({
    color: colorConvert,
    alpha
  });
  const [change, setChange] = useState(false);

  useEffect(() => {
    if (!change) {
      setState({
        color: colorConvert,
        alpha
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hex, alpha]);

  const handleAlphaChange = (alpha: number) => {
    setChange(true);
    const { color } = state;
    color.alpha = alpha;

    setState({
      color,
      alpha
    });
    onChange({
      hex: color.toHexString(),
      alpha
    });
  };

  const handleChange = (color: ITinyColor) => {
    setChange(true);
    const { alpha } = state;
    color.alpha = alpha;

    setState({ ...state, color, alpha: color.alpha });
    onChange({
      hex: color.toHexString(),
      alpha: color.alpha
    });
  };

  return (
    <div
      ref={node}
      className={clsx('z-[9] select-none rounded outline-none', className)}
      tabIndex={0}
    >
      <div>
        <Board
          color={state.color}
          colorBoardHeight={colorBoardHeight}
          onChange={handleChange}
          setChange={setChange}
        />

        {/* Com alpha as duas barras dividem uma faixa de 36px; sem alpha, só a de matiz. */}
        <div
          className={clsx(
            'relative flex w-full flex-col justify-between',
            showAlpha && 'h-9'
          )}
        >
          <div className='h-2'>
            <Ribbon
              color={state.color}
              onChange={handleChange}
              setChange={setChange}
            />
          </div>

          {showAlpha && (
            <div className='h-2'>
              <Alpha
                alpha={state.alpha}
                color={state.color}
                onChange={handleAlphaChange}
                setChange={setChange}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Panel;
